import { defineWorkspaceEntityHydration } from '#layers/runtime/public';

/** The persisted-state rows of a workspace runtime; `usePersistedState` reads them by key from the warmed cache. */
// TODO filter on current user client-side or server-side
export const workspaceKeyStorageHydration = defineWorkspaceEntityHydration((store) => store.MonospaceKeyStorage.query((q) => q.many()), { empty: [] });
